import PropTypes from "prop-types";
import clsx from "classnames";
import classes from "./styles.module.scss";

export default function Chatbot({ className, chatbot }) {
  return (
    <div className={clsx(className, classes.chatbot)}>
      <div dangerouslySetInnerHTML={{ __html: chatbot }} />
    </div>
  );
}

Chatbot.defaultProps = {
  className: "",
};

Chatbot.propTypes = {
  className: PropTypes.string,
};
